<template>
  <section class="section">
    <div class="is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title">Usuários</h1>
          </div>
        </div>
        <div class="level-right" id="topTable">
          <div class="level-item">
            <b-button
              icon-right="plus"
              type="is-primary"
              @click="dialog = true"
            >
              Adicionar
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card has-table">
      <b-table
        :data="desserts"
        :paginated="true"
        :pagination-simple="true"
        :per-page="perPage"
        striped
      >
        <template slot-scope="props">
          <b-table-column field="name" label="Nome" sortable>{{
            props.row.name
          }}</b-table-column>
          <b-table-column field="username" label="Username" sortable>{{
            props.row.username
          }}</b-table-column>
          <b-table-column field="email" label="Email" sortable>{{
            props.row.email
          }}</b-table-column>
          <b-table-column field="client.name" label="Cliente" sortable>{{
            props.row.is_adm
              ? props.row.group
                ? props.row.group.text
                : "no group"
              : props.row.client
              ? props.row.client.name
              : "ELCOMA"
          }}</b-table-column>

          <b-table-column field="is_adm" label="Admin" sortable>
            <b-icon
              :icon="props.row.is_adm ? 'check-circle' : ''"
              type="is-success"
            ></b-icon>
          </b-table-column>

          <b-table-column field="actions" label="Actions">
            <b-button
              icon-right="edit"
              size="is-small"
              type="is-info"
              @click="editItem(props.row)"
              >Editar</b-button
            >
            <b-button
              icon-right="trash"
              size="is-small"
              type="is-danger"
              @click="deleteItem(props.row)"
              >Excluir</b-button
            >
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="has-text-grey has-text-centered">
              <span>Sem pessoas para exibir</span>
            </div>
          </section>
        </template>
        <template slot="footer">
          <div class="level" style="padding-bottom: 0">
            <div class="level-left"></div>
            <div class="left-center"></div>
            <div class="level-right">
              <b-select v-model="perPage" size="is-small">
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </b-select>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <b-modal
      :active.sync="dialog"
      has-modal-card
      trap-focus
      :can-cancel="false"
      aria-role="dialog"
      aria-modal
    >
      <form action="">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Novo Usuário</p>
          </header>
          <section class="modal-card-body">
            <b-field
              label="Nome do Usuário"
              label-position="on-border"
              type="is-primary"
            >
              <b-input type="text" v-model="editedItem.name" required>
              </b-input>
            </b-field>

            <b-field
              label="Nome de Usuário"
              label-position="on-border"
              type="is-primary"
            >
              <b-input type="text" v-model="editedItem.username" required>
              </b-input>
            </b-field>
            <b-field
              label="E-mail"
              label-position="on-border"
              type="is-primary"
            >
              <b-input
                expanded
                type="email"
                v-model="editedItem.email"
                required
              >
              </b-input>
            </b-field>

            <b-field>
              <b-checkbox type="is-primary" v-model="editedItem.is_adm"
                >Administrador</b-checkbox
              >
            </b-field>

            <b-field
              v-if="editedItem.is_adm"
              label="Grupo"
              label-position="on-border"
              type="is-primary"
            >
              <b-select
                expanded
                placeholder="Selecione o grupo"
                v-model="editedItem.group"
              >
                <option v-for="option in groups" :value="option" :key="option">
                  {{ option.text }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-else
              label="Empresa"
              label-position="on-border"
              type="is-primary"
            >
              <b-select
                placeholder="Selecione a empresa"
                expanded
                v-model="editedItem.client"
                @input="changeClient"
              >
                <option v-for="option in clients" :value="option" :key="option">
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>

            <b-field label="Permissões"></b-field>

            <div v-for="(item, index) in getRules" :key="index">
              <b-field horizontal :label="item">
                <b-checkbox
                  type="is-primary"
                  v-for="option in getRuleOptions(item)"
                  :key="option"
                  v-model="editedItem.rules[item][option]"
                >
                  {{ option }}
                </b-checkbox>
              </b-field>
              <div class="is-divider"></div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button @click="close">
              Cancelar
            </b-button>
            <b-button type="is-primary" @click.native="save">
              Salvar
            </b-button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import Webservices from "@/Webservices";
import { mapGetters, mapActions } from "vuex";

const ws = new Webservices();

export default {
  name: "Usuarios",
  data: () => ({
    perPage: 10,
    currentRule: undefined,
    clients: [],
    groups: [],
    imageUploaded: false,

    loading3: false,
    modal: false,

    dialog: false,

    headers: [
      {
        text: "Nome",
        value: "name"
      },
      { text: "Username", value: "username" },
      { text: "E-Mail", value: "email" },
      { text: "Empresa", value: "client_name" },
      { text: "Administrador", value: "is_adm" },
      { text: "Actions", align: "center", value: "name", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      username: "",
      email: "",
      password: "",
      is_adm: false,
      client: { name: "" },
      group: { text: "" },
      rules: {
        questions: {
          list: true,
          edit: true
        },
        videos: {
          list: true,
          edit: true
        },
        vouchers: {
          list: true,
          edit: true
        },
        dashboard: {
          list: true
        },
        acessos: {
          list: true
        },
        radios: {
          list: true
        }
      }
    },
    defaultItem: {
      name: "",
      username: "",
      email: "",
      password: "",
      is_adm: false,
      client: { name: "" },
      group: { text: "" },
      rules: {
        questions: {
          list: true,
          edit: true
        },
        videos: {
          list: true,
          edit: true
        },
        vouchers: {
          list: true,
          edit: true
        },
        dashboard: {
          list: true
        },
        acessos: {
          list: true
        },
        radios: {
          list: true
        }
      }
    }
  }),
  computed: {
    ...mapGetters(["isADM", "isROOT", "getGroup", "getUserId", "getToken"]),
    formTitle() {
      return this.editedIndex === -1 ? "Novo Usuário" : "Editar";
    },
    getRules() {
      var saida = null;

      try {
        saida = Object.keys(this.editedItem.rules);
      } catch (exc) {
        saida = [];
      }

      return saida;
    }
  },

  async mounted() {
    if (await ws.checkAccessToken(this.getToken)) {
      this.logout();
      this.$router.push("/login");
    }
    ws.setToken(this.getToken);

    if (this.isROOT) {
      ws.getUsers().then(response => {
        this.desserts = response.data;
      });
      ws.getGroups().then(response => {
        this.groups = response.data;
      });

      ws.getClients().then(response => {
        this.clients = response.data;
      });
    } else if (this.isADM) {
      ws.getUsersByGroupId(this.getGroup.id).then(response => {
        this.desserts = response.data;

        this.groups = [this.getGroup];

        this.defaultItem.group = this.getGroup;
        this.editedItem.group = this.getGroup;
      });

      ws.getClientsByGroupId(this.getGroup.id).then(response => {
        this.clients = response.data;

        this.clients.forEach(client => {
          ws.getUsersByClientId(client.id).then(response2 => {
            this.desserts = this.desserts.concat(response2.data);
          });
        });
      });
    }
  },

  watch: {},

  created() {
    //this.initialize();
  },

  methods: {
    ...mapActions(["logout"]),
    initialize() {},

    getRuleOptions(rule) {
      var saida = [];

      if (rule) saida = Object.keys(this.editedItem.rules[rule]);

      return saida;
    },

    changeClient(value) {
      this.editedItem.client = {
        name: value.name,
        id: value.id,
        controller_id: value.controller_id
      };
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = item;

      this.currentRule = undefined;

      if (!this.editedItem.hasOwnProperty("rules"))
        this.editedItem["rules"] = this.defaultItem.rules;

      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      if (confirm("Você tem certeza que deseja remover esse usuário?")) {
        this.desserts.splice(index, 1);
        ws.deleteUser(item.id).then(response => {});
      }
    },

    close() {
      this.dialog = false;

      this.currentRule = undefined;

      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedItem.is_adm && !this.editedItem.group) {
        alert(
          "O usuário está assinalado como Administrador, mas está sem grupo"
        );
      } else if (!this.editedItem.is_adm && this.editedItem.client.name == "") {
        alert("O usuário está sem um cliente associado");
      } else if (
        this.editedItem.username == "" ||
        this.editedItem.name == "" ||
        this.editedItem.email == ""
      ) {
        alert("Preencha todos os campos");
      } else {
        if (this.editedIndex > -1) {
          delete this.editedItem["password"];
          Object.assign(this.desserts[this.editedIndex], this.editedItem);
          ws.updateUser(this.editedItem).then(response => {});
        } else {
          this.editedItem.password = this.editedItem.username;
          this.desserts.push(this.editedItem);
          ws.saveUser(this.editedItem).then(response => {});
        }
        this.close();
      }
    }
  }
};
</script>

<style scoped>
#topTable {
  padding-bottom: 10px;
}
.capitalize {
  text-transform: capitalize !important;
}

input {
  margin: 0.4rem;
  border: solid thin darkgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Usuarios.vue